
import { tokens } from "../../theme/theme";
import {  Typography, Card, CardContent, Grid,  Button, useTheme, Box, } from "@mui/material";

// icons 

import BoltIcon from '@mui/icons-material/Bolt';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { useTranslation } from "react-i18next";


const CostingManagementMenu = ({ SetActive, handleBackDashboard }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();
   

    const callback = () => {
        handleBackDashboard();
    };

    return (
        <Box >
            {/* <Box sx={{ backgroundColor: colors.primary[400], minHeight: "100vh" }}> */}
            <Card sx={{ backgroundColor: "transparent", borderRadius:"0px", height:"48px", justifyContent:"center" }}>
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h5" color={colors.grey[100]} fontWeight="bold" justifyContent="center">{t('prod_menu.costingmanagement')} </Typography>
                    </Box>
                </CardContent>
            </Card>
           
            {/* scan bar code */}
            {/* <Divider /> */}


            {/* <Divider /> */}
            <Box p={2}>
                <Grid container spacing={2} justifyContent="start" marginTop="0px"  >


                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <BoltIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>Power Consumption</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("power-consumption")}>Set</Button>
                        </Card>
                    </Grid>


                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <ReceiptIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>Costing</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("costing")}>Get</Button>
                        </Card>
                    </Grid>




                    {/* Repeat the Grid item for each production entry */}
                    {/* You can customize the style and content for each card */}
                </Grid>
            </Box>
        </Box>

    )
}
export default CostingManagementMenu;





